import styled from 'styled-components';

export const SInputGroup = styled.section<{}>(({ theme }) => {
  return `
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
  `;
});

export const SInputGap = styled.div(() => ({
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 0,
}));
export const SInputGroupTitle = styled.div`
  display: flex;
  align-items: center;
`;
export const STooltipWrapper = styled.div`
  margin-left: 5px;
`;
export const SInputLabel = styled.div`
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
  color: #002169;
`;

export const SErrorMessage = styled.span<{ error: string }>(({ error }) => {
  return `
    font-family: 'Poppins';
    font-size: 12px;
    font-style: normal;
    line-height: 15px;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 2px;
    color: ${error.length ? '#ED726B' : 'transparent'};
    visibility: ${error.length ? 'visible' : 'hidden'};
    height: 16px;
  `;
});
